import { Component, Output,EventEmitter, OnInit, Input, ElementRef, AfterViewInit } from '@angular/core';
import { SessionService } from '../shared/services/session.service';
import { LyssnapaalfabetetcapsComponent } from '../fk-alphabetshelf/lyssna-pa-alfabetet-caps/lyssna-pa-alfabetet-caps.component';
//import { LyssnapaalfabetetsmallComponent } from '../fk-alphabetshelf/lyssna-pa-alfabetet-small/lyssna-pa-alfabetet-small.component';
//import { AlfabetetComponent } from '../fk-alphabetshelf/alfabetet/alfabetet.component';
//import { BokstaverviovatComponent } from '../fk-alphabetshelf/bokstaver-vi-ovat/bokstaver-vi-ovat.component';
import { Router } from '@angular/router';
import { MatSnackBar } from "@angular/material";
/*import { SapbubblorComponent } from '../fk-tincan/sapbubblor/sapbubblor.component';*/
import { LyssnaEfterLjudetComponent } from '../fk-tincan/lyssna-efter-ljudet/lyssna-efter-ljudet.component';
//import { KnasigameningarComponent } from '../fk-tincan/knasigameningar/knasigameningar.component';
//import { BladderblocketComponent } from '../fk-tincan/bladderblocket/bladderblocket.component';
//import { SangAlfabetetComponent } from '../fk-alphabetshelf/sang-alfabetet/sang-alfabetet.component';
//import { SangAlfabetetSjungMedComponent } from '../fk-alphabetshelf/sang-alfabetet-sjung-med/sang-alfabetet-sjung-med.component';
import { MatDialog } from '@angular/material';
import { ViewEncapsulation } from '@angular/core';
import * as $ from "jquery";
declare var document: any;



@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class NavMenuComponent implements OnInit, AfterViewInit {

  @Output() closeNavEvent = new EventEmitter<string>();
  closeNavChild(): void {
      this.closeNavEvent.next();
    }


  @Output() openNavEvent = new EventEmitter<string>();
  openNavChild(): void {
      this.openNavEvent.next();
    }

  dialogResult = "";
  public firstName: string;
  public lastName: string;
  public isAuthenicated: Boolean = false;
  public endDateTime: string;
  public blockUI: Boolean;
  public currentRoute: string;
  public title: string;
  public version: string;
  public webApiEndPoint: string;
  public imagesDirectory: string;
  public bloburl: string;
  public logurl: string;


  constructor(

    public dialog: MatDialog,
     public snackBar: MatSnackBar,
    private sessionService: SessionService,
    private router: Router,
    private elementRef: ElementRef) {

    this.logurl = this.sessionService.logouturl;
    this.bloburl = this.sessionService.bloburl;
    var current_url = "";
    var old_url = "";
    this.router.events.subscribe((val) => {
      current_url = this.router.url;
      if (current_url != old_url) {
        this.setmenulayout();
        this.menuactive();
        old_url = current_url;
      }
    });
  }
  menuactive() {

    var a = $("#menu_ReadBook_img").width();
    var b = $("#menu_ReadBook_img").height();
    var width_sub = 3;
    var height_add = 20;
    if (a > 0 && b > 0) {
      $("#menu_ReadBook_active").width((a - width_sub) + "px");
      $("#menu_ReadBook_active").height((b + height_add) + "px");
      var a = $("#menu_WorkBook_img").width();
      var b = $("#menu_WorkBook_img").height();
      $("#menu_WorkBook_active").width((a - width_sub) + "px");
      $("#menu_WorkBook_active").height((b + height_add) + "px");

    }
  }


  setmenulayout() {

    var nav_open = $(".sidenav").css('margin-left');
    if (nav_open != "0px") {      

    }
  }
  setmenuactive() {

    var page_active = this.router.url;
    var readbooks_url = ["/fk-rb-index",
      //"/rbpagech01/fk-rb-pgs-ch01-page6",
      //"/rbpagech01/fk-rb-pgs-ch01-page7",
      //"/rbpagech01/fk-rb-pgs-ch01-page8",
      //"/rbpagech01/fk-rb-pgs-ch01-page9",
      //"/rbpagech01/fk-rb-pgs-ch01-page10",
      //"/rbpagech01/fk-rb-pgs-ch01-page11",
      //"/rbpagech01/fk-rb-pgs-ch01-page12",
      //"/rbpagech01/fk-rb-pgs-ch01-page13",

      //"/rbpagech02/fk-rb-pgs-ch02-page14",
      //"/rbpagech02/fk-rb-pgs-ch02-page15",
      //"/rbpagech02/fk-rb-pgs-ch02-page16",
      //"/rbpagech02/fk-rb-pgs-ch02-page17",
      //"/rbpagech02/fk-rb-pgs-ch02-page18",
      //"/rbpagech02/fk-rb-pgs-ch02-page19",
      //"/rbpagech02/fk-rb-pgs-ch02-page20",
      //"/rbpagech02/fk-rb-pgs-ch02-page21",
      //"/rbpagech02/fk-rb-pgs-ch02-page22",
      //"/rbpagech02/fk-rb-pgs-ch02-page23",
      //"/rbpagech02/fk-rb-pgs-ch02-page24",
      //"/rbpagech02/fk-rb-pgs-ch02-page25",

      //"/rbpagech03/fk-rb-pgs-ch03-page26",
      //"/rbpagech03/fk-rb-pgs-ch03-page27",
      //"/rbpagech03/fk-rb-pgs-ch03-page28",
      //"/rbpagech03/fk-rb-pgs-ch03-page29",
      //"/rbpagech03/fk-rb-pgs-ch03-page30",
      //"/rbpagech03/fk-rb-pgs-ch03-page31",
      //"/rbpagech03/fk-rb-pgs-ch03-page32",
      //"/rbpagech03/fk-rb-pgs-ch03-page33",
      //"/rbpagech03/fk-rb-pgs-ch03-page34",
      //"/rbpagech03/fk-rb-pgs-ch03-page35",
      //"/rbpagech03/fk-rb-pgs-ch03-page36",
      //"/rbpagech03/fk-rb-pgs-ch03-page37",

      //"/rbpagech04/fk-rb-pgs-ch04-page38",
      //"/rbpagech04/fk-rb-pgs-ch04-page39",
      //"/rbpagech04/fk-rb-pgs-ch04-page40",
      //"/rbpagech04/fk-rb-pgs-ch04-page41",
      //"/rbpagech04/fk-rb-pgs-ch04-page42",
      //"/rbpagech04/fk-rb-pgs-ch04-page43",
      //"/rbpagech04/fk-rb-pgs-ch04-page44",
      //"/rbpagech04/fk-rb-pgs-ch04-page45",
      //"/rbpagech04/fk-rb-pgs-ch04-page46",
      //"/rbpagech04/fk-rb-pgs-ch04-page47",
      //"/rbpagech04/fk-rb-pgs-ch04-page48",
      //"/rbpagech04/fk-rb-pgs-ch04-page49",
      //"/rbpagech04/fk-rb-pgs-ch04-page50",

      //"/rbpagech05/fk-rb-pgs-ch05-page52",
      //"/rbpagech05/fk-rb-pgs-ch05-page53",
      //"/rbpagech05/fk-rb-pgs-ch05-page54",
      //"/rbpagech05/fk-rb-pgs-ch05-page56",
      //"/rbpagech05/fk-rb-pgs-ch05-page58",
      //"/rbpagech05/fk-rb-pgs-ch05-page60",
      //"/rbpagech05/fk-rb-pgs-ch05-page61",
      //"/rbpagech05/fk-rb-pgs-ch05-page62",
      //"/rbpagech05/fk-rb-pgs-ch05-page63",

      "/rbpagech06/fk-rb-pgs-ch06-page64",
      "/rbpagech06/fk-rb-pgs-ch06-page65",
      "/rbpagech06/fk-rb-pgs-ch06-page66",
      "/rbpagech06/fk-rb-pgs-ch06-page67",
      "/rbpagech06/fk-rb-pgs-ch06-page68",
      "/rbpagech06/fk-rb-pgs-ch06-page69",
      "/rbpagech06/fk-rb-pgs-ch06-page70",
      "/rbpagech06/fk-rb-pgs-ch06-page71",
      "/rbpagech06/fk-rb-pgs-ch06-page72",
      "/rbpagech06/fk-rb-pgs-ch06-page73",
      "/rbpagech06/fk-rb-pgs-ch06-page74",
      "/rbpagech06/fk-rb-pgs-ch06-page75",

      //"/rbpagech07/fk-rb-pgs-ch07-page76",
      //"/rbpagech07/fk-rb-pgs-ch07-page77",
      //"/rbpagech07/fk-rb-pgs-ch07-page78",
      //"/rbpagech07/fk-rb-pgs-ch07-page79",
      //"/rbpagech07/fk-rb-pgs-ch07-page80",
      //"/rbpagech07/fk-rb-pgs-ch07-page82",
      //"/rbpagech07/fk-rb-pgs-ch07-page83",

      //"/rbpagech08/fk-rb-pgs-ch08-page84",
      //"/rbpagech08/fk-rb-pgs-ch08-page85",
      //"/rbpagech08/fk-rb-pgs-ch08-page86",
      //"/rbpagech08/fk-rb-pgs-ch08-page87",
      //"/rbpagech08/fk-rb-pgs-ch08-page88",
      //"/rbpagech08/fk-rb-pgs-ch08-page89",
      //"/rbpagech08/fk-rb-pgs-ch08-page90",
      //"/rbpagech08/fk-rb-pgs-ch08-page91",
      //"/rbpagech08/fk-rb-pgs-ch08-page92",
      //"/rbpagech08/fk-rb-pgs-ch08-page93",
      //"/rbpagech08/fk-rb-pgs-ch08-page94",
      //"/rbpagech08/fk-rb-pgs-ch08-page95",
      //"/rbpagech08/fk-rb-pgs-ch08-page96",
      //"/rbpagech08/fk-rb-pgs-ch08-page97",
      //"/rbpagech08/fk-rb-pgs-ch08-page98",

      //"/rbpagech09/fk-rb-pgs-ch09-page100",
      //"/rbpagech09/fk-rb-pgs-ch09-page101",
      //"/rbpagech09/fk-rb-pgs-ch09-page102",
      //"/rbpagech09/fk-rb-pgs-ch09-page103",
      //"/rbpagech09/fk-rb-pgs-ch09-page104",
      //"/rbpagech09/fk-rb-pgs-ch09-page105",
      //"/rbpagech09/fk-rb-pgs-ch09-page106",
      //"/rbpagech09/fk-rb-pgs-ch09-page107",
      //"/rbpagech09/fk-rb-pgs-ch09-page108",
      //"/rbpagech09/fk-rb-pgs-ch09-page109",
      //"/rbpagech09/fk-rb-pgs-ch09-page110",
      //"/rbpagech09/fk-rb-pgs-ch09-page111",
      //"/rbpagech09/fk-rb-pgs-ch09-page112",
      //"/rbpagech09/fk-rb-pgs-ch09-page113",

      //"/rbpagech10/fk-rb-pgs-ch10-page114",
      //"/rbpagech10/fk-rb-pgs-ch10-page115",
      //"/rbpagech10/fk-rb-pgs-ch10-page116",
      //"/rbpagech10/fk-rb-pgs-ch10-page118",
      //"/rbpagech10/fk-rb-pgs-ch10-page120",
      //"/rbpagech10/fk-rb-pgs-ch10-page122",
      //"/rbpagech10/fk-rb-pgs-ch10-page124",
      //"/rbpagech10/fk-rb-pgs-ch10-page126",
      //"/rbpagech10/fk-rb-pgs-ch10-page127",
      //"/rbpagech10/fk-rb-pgs-ch10-page128",
      //"/rbpagech10/fk-rb-pgs-ch10-page129",


      //"/rbpagech11/fk-rb-pgs-ch11-page130",
      //"/rbpagech11/fk-rb-pgs-ch11-page131",
      //"/rbpagech11/fk-rb-pgs-ch11-page132",
      //"/rbpagech11/fk-rb-pgs-ch11-page133",
      //"/rbpagech11/fk-rb-pgs-ch11-page134",
      //"/rbpagech11/fk-rb-pgs-ch11-page135",
      //"/rbpagech11/fk-rb-pgs-ch11-page136",
      //"/rbpagech11/fk-rb-pgs-ch11-page137",
      //"/rbpagech11/fk-rb-pgs-ch11-page138",
      //"/rbpagech11/fk-rb-pgs-ch11-page139",
      //"/rbpagech11/fk-rb-pgs-ch11-page140",
      //"/rbpagech11/fk-rb-pgs-ch11-page141",

      //"/rbpagech12/fk-rb-pgs-ch12-page142",
      //"/rbpagech12/fk-rb-pgs-ch12-page143",
      //"/rbpagech12/fk-rb-pgs-ch12-page144",
      //"/rbpagech12/fk-rb-pgs-ch12-page146",
      //"/rbpagech12/fk-rb-pgs-ch12-page147",
      //"/rbpagech12/fk-rb-pgs-ch12-page148",
      //"/rbpagech12/fk-rb-pgs-ch12-page150",
      //"/rbpagech12/fk-rb-pgs-ch12-page152",
      //"/rbpagech12/fk-rb-pgs-ch12-page154",
      //"/rbpagech12/fk-rb-pgs-ch12-page156",
      //"/rbpagech12/fk-rb-pgs-ch12-page157",
      //"/rbpagech12/fk-rb-pgs-ch12-page158",
      //"/rbpagech12/fk-rb-pgs-ch12-page159",
      //"/rbpagech12/fk-rb-pgs-ch12-page160",
      //"/rbpagech12/fk-rb-pgs-ch12-page161",
      //"/rbpagech12/fk-rb-pgs-ch12-page162",
      //"/rbpagech12/fk-rb-pgs-ch12-page163",
      //"/rbpagech12/fk-rb-pgs-ch12-page164",

    ];


    var workbooks_url = [
      "/fk-wb-index",
      //"/wbpagech01/fk-wb-pgs-ch01-page4",
      //"/wbpagech01/fk-wb-pgs-ch01-page5",
      //"/wbpagech01/fk-wb-pgs-ch01-page6",
      //"/wbpagech01/fk-wb-pgs-ch01-page7",

      //"/wbpagech02/fk-wb-pgs-ch02-page8",
      //"/wbpagech02/fk-wb-pgs-ch02-page9",
      //"/wbpagech02/fk-wb-pgs-ch02-page10",
      //"/wbpagech02/fk-wb-pgs-ch02-page11",

      //"/wbpagech03/fk-wb-pgs-ch03-page12",
      //"/wbpagech03/fk-wb-pgs-ch03-page13",
      //"/wbpagech03/fk-wb-pgs-ch03-page14",
      //"/wbpagech03/fk-wb-pgs-ch03-page15",

      //"/wbpagech04/fk-wb-pgs-ch04-page16",
      //"/wbpagech04/fk-wb-pgs-ch04-page17",
      //"/wbpagech04/fk-wb-pgs-ch04-page18",
      //"/wbpagech04/fk-wb-pgs-ch04-page19",

      //"/wbpagech05/fk-wb-pgs-ch05-page20",
      //"/wbpagech05/fk-wb-pgs-ch05-page21",
      //"/wbpagech05/fk-wb-pgs-ch05-page22",
      //"/wbpagech05/fk-wb-pgs-ch05-page23",

      "/wbpagech06/fk-wb-pgs-ch06-page24",
      "/wbpagech06/fk-wb-pgs-ch06-page25",
      "/wbpagech06/fk-wb-pgs-ch06-page26",
      "/wbpagech06/fk-wb-pgs-ch06-page27",

      //"/wbpagech07/fk-wb-pgs-ch07-page28",
      //"/wbpagech07/fk-wb-pgs-ch07-page29",
      //"/wbpagech07/fk-wb-pgs-ch07-page30",
      //"/wbpagech07/fk-wb-pgs-ch07-page31",

      //"/wbpagech08/fk-wb-pgs-ch08-page32",
      //"/wbpagech08/fk-wb-pgs-ch08-page33",
      //"/wbpagech08/fk-wb-pgs-ch08-page34",
      //"/wbpagech08/fk-wb-pgs-ch08-page35",

      //"/wbpagech09/fk-wb-pgs-ch09-page36",
      //"/wbpagech09/fk-wb-pgs-ch09-page37",
      //"/wbpagech09/fk-wb-pgs-ch09-page38",
      //"/wbpagech09/fk-wb-pgs-ch09-page39",

      //"/wbpagech10/fk-wb-pgs-ch10-page40",
      //"/wbpagech10/fk-wb-pgs-ch10-page41",
      //"/wbpagech10/fk-wb-pgs-ch10-page42",
      //"/wbpagech10/fk-wb-pgs-ch10-page43",

      //"/wbpagech11/fk-wb-pgs-ch11-page44",
      //"/wbpagech11/fk-wb-pgs-ch11-page45",
      //"/wbpagech11/fk-wb-pgs-ch11-page46",
      //"/wbpagech11/fk-wb-pgs-ch11-page47",

      //"/wbpagech12/fk-wb-pgs-ch12-page48",
      //"/wbpagech12/fk-wb-pgs-ch12-page49",
      //"/wbpagech12/fk-wb-pgs-ch12-page50",
      //"/wbpagech12/fk-wb-pgs-ch12-page51",
      //"/wbpagech12/fk-wb-pgs-ch12-page52",
      //"/wbpagech12/fk-wb-pgs-ch12-page53",
      //"/wbpagech12/fk-wb-pgs-ch12-page54",
      //"/wbpagech12/fk-wb-pgs-ch12-page55",



    ];




    $("#menu_ReadBook_active").hide();
    $("#menu_WorkBook_active").hide();

    if (readbooks_url.indexOf(page_active) > - 1) {
      $("#menu_ReadBook_active").css("display", "block");
    }
    else if (workbooks_url.indexOf(page_active) > - 1) {
      $("#menu_WorkBook_active").css("display", "block");
    }

    $(".rb_ch").hide();
    $(".wb_ch").hide();

    var other_url = [
      "/home",
      "/"
    ];
    //var workbookch1_url = [

    //  "/wbpagech01/fk-wb-pgs-ch01-page4",
    //  "/wbpagech01/fk-wb-pgs-ch01-page5",
    //  "/wbpagech01/fk-wb-pgs-ch01-page6",
    //  "/wbpagech01/fk-wb-pgs-ch01-page7"
    //];

    //var workbookch2_url = [
    //  "/wbpagech02/fk-wb-pgs-ch02-page8",
    //  "/wbpagech02/fk-wb-pgs-ch02-page9",
    //  "/wbpagech02/fk-wb-pgs-ch02-page10",
    //  "/wbpagech02/fk-wb-pgs-ch02-page11"
    //];

    //var workbookch3_url = [
    //  "/wbpagech03/fk-wb-pgs-ch03-page12",
    //  "/wbpagech03/fk-wb-pgs-ch03-page13",
    //  "/wbpagech03/fk-wb-pgs-ch03-page14",
    //  "/wbpagech03/fk-wb-pgs-ch03-page15"
    //];

    //var workbookch4_url = [
    //  "/wbpagech04/fk-wb-pgs-ch04-page16",
    //  "/wbpagech04/fk-wb-pgs-ch04-page17",
    //  "/wbpagech04/fk-wb-pgs-ch04-page18",
    //  "/wbpagech04/fk-wb-pgs-ch04-page19",
    //];

    //var workbookch5_url = [
    //  "/wbpagech05/fk-wb-pgs-ch05-page20",
    //  "/wbpagech05/fk-wb-pgs-ch05-page21",
    //  "/wbpagech05/fk-wb-pgs-ch05-page22",
    //  "/wbpagech05/fk-wb-pgs-ch05-page23"

    //];

    var workbookch6_url = [
      "/wbpagech06/fk-wb-pgs-ch06-page24",
      "/wbpagech06/fk-wb-pgs-ch06-page25",
      "/wbpagech06/fk-wb-pgs-ch06-page26",
      "/wbpagech06/fk-wb-pgs-ch06-page27"
    ];

    //var workbookch7_url = [
    //  "/wbpagech07/fk-wb-pgs-ch07-page28",
    //  "/wbpagech07/fk-wb-pgs-ch07-page29",
    //  "/wbpagech07/fk-wb-pgs-ch07-page30",
    //  "/wbpagech07/fk-wb-pgs-ch07-page31"
    //];
    //var workbookch8_url = [
    //  "/wbpagech08/fk-wb-pgs-ch08-page32",
    //  "/wbpagech08/fk-wb-pgs-ch08-page33",
    //  "/wbpagech08/fk-wb-pgs-ch08-page34",
    //  "/wbpagech08/fk-wb-pgs-ch08-page35",
    //];
    //var workbookch9_url = [
    //  "/wbpagech09/fk-wb-pgs-ch09-page36",
    //  "/wbpagech09/fk-wb-pgs-ch09-page37",
    //  "/wbpagech09/fk-wb-pgs-ch09-page38",
    //  "/wbpagech09/fk-wb-pgs-ch09-page39"
    //];

    //var workbookch10_url = [
    //  "/wbpagech10/fk-wb-pgs-ch10-page40",
    //  "/wbpagech10/fk-wb-pgs-ch10-page41",
    //  "/wbpagech10/fk-wb-pgs-ch10-page42",
    //  "/wbpagech10/fk-wb-pgs-ch10-page43"
    //]
    //var workbookch11_url = [
    //  "/wbpagech11/fk-wb-pgs-ch11-page44",
    //  "/wbpagech11/fk-wb-pgs-ch11-page45",
    //  "/wbpagech11/fk-wb-pgs-ch11-page46",
    //  "/wbpagech11/fk-wb-pgs-ch11-page47"
    //]
    //var workbookch12_url = [
    //  "/wbpagech12/fk-wb-pgs-ch12-page48",
    //  "/wbpagech12/fk-wb-pgs-ch12-page49",
    //  "/wbpagech12/fk-wb-pgs-ch12-page50",
    //  "/wbpagech12/fk-wb-pgs-ch12-page51",
    //  "/wbpagech12/fk-wb-pgs-ch12-page52",
    //  "/wbpagech12/fk-wb-pgs-ch12-page53",
    //  "/wbpagech12/fk-wb-pgs-ch12-page54",
    //  "/wbpagech12/fk-wb-pgs-ch12-page55"
    //]

    //var readbookch1_url = [
    //  "/rbpagech01/fk-rb-pgs-ch01-page6",
    //  "/rbpagech01/fk-rb-pgs-ch01-page7",
    //  "/rbpagech01/fk-rb-pgs-ch01-page8",
    //  "/rbpagech01/fk-rb-pgs-ch01-page9",
    //  "/rbpagech01/fk-rb-pgs-ch01-page10",
    //  "/rbpagech01/fk-rb-pgs-ch01-page11",
    //  "/rbpagech01/fk-rb-pgs-ch01-page12",
    //  "/rbpagech01/fk-rb-pgs-ch01-page13"
    //];
    //var readbookch2_url = [
    //  "/rbpagech02/fk-rb-pgs-ch02-page14",
    //  "/rbpagech02/fk-rb-pgs-ch02-page15",
    //  "/rbpagech02/fk-rb-pgs-ch02-page16",
    //  "/rbpagech02/fk-rb-pgs-ch02-page17",
    //  "/rbpagech02/fk-rb-pgs-ch02-page18",
    //  "/rbpagech02/fk-rb-pgs-ch02-page19",
    //  "/rbpagech02/fk-rb-pgs-ch02-page20",
    //  "/rbpagech02/fk-rb-pgs-ch02-page21",
    //  "/rbpagech02/fk-rb-pgs-ch02-page22",
    //  "/rbpagech02/fk-rb-pgs-ch02-page23",
    //  "/rbpagech02/fk-rb-pgs-ch02-page24",
    //  "/rbpagech02/fk-rb-pgs-ch02-page25"
    //];
    //var readbookch3_url = [
    //  "/rbpagech03/fk-rb-pgs-ch03-page26",
    //  "/rbpagech03/fk-rb-pgs-ch03-page27",
    //  "/rbpagech03/fk-rb-pgs-ch03-page28",
    //  "/rbpagech03/fk-rb-pgs-ch03-page29",
    //  "/rbpagech03/fk-rb-pgs-ch03-page30",
    //  "/rbpagech03/fk-rb-pgs-ch03-page31",
    //  "/rbpagech03/fk-rb-pgs-ch03-page32",
    //  "/rbpagech03/fk-rb-pgs-ch03-page33",
    //  "/rbpagech03/fk-rb-pgs-ch03-page34",
    //  "/rbpagech03/fk-rb-pgs-ch03-page35",
    //  "/rbpagech03/fk-rb-pgs-ch03-page36",
    //  "/rbpagech03/fk-rb-pgs-ch03-page37"

    //];
    //var readbookch4_url = [
    //  "/rbpagech04/fk-rb-pgs-ch04-page38",
    //  "/rbpagech04/fk-rb-pgs-ch04-page39",
    //  "/rbpagech04/fk-rb-pgs-ch04-page40",
    //  "/rbpagech04/fk-rb-pgs-ch04-page41",
    //  "/rbpagech04/fk-rb-pgs-ch04-page42",
    //  "/rbpagech04/fk-rb-pgs-ch04-page43",
    //  "/rbpagech04/fk-rb-pgs-ch04-page44",
    //  "/rbpagech04/fk-rb-pgs-ch04-page45",
    //  "/rbpagech04/fk-rb-pgs-ch04-page46",
    //  "/rbpagech04/fk-rb-pgs-ch04-page47",
    //  "/rbpagech04/fk-rb-pgs-ch04-page48",
    //  "/rbpagech04/fk-rb-pgs-ch04-page49",
    //  "/rbpagech04/fk-rb-pgs-ch04-page50"
    //];

    //var readbookch5_url = [
    //  "/rbpagech05/fk-rb-pgs-ch05-page52",
    //  "/rbpagech05/fk-rb-pgs-ch05-page53",
    //  "/rbpagech05/fk-rb-pgs-ch05-page54",
    //  "/rbpagech05/fk-rb-pgs-ch05-page56",
    //  "/rbpagech05/fk-rb-pgs-ch05-page58",
    //  "/rbpagech05/fk-rb-pgs-ch05-page60",
    //  "/rbpagech05/fk-rb-pgs-ch05-page61",
    //  "/rbpagech05/fk-rb-pgs-ch05-page62",
    //  "/rbpagech05/fk-rb-pgs-ch05-page63"
    //];
    var readbookch6_url = [
      "/rbpagech06/fk-rb-pgs-ch06-page64",
      "/rbpagech06/fk-rb-pgs-ch06-page65",
      "/rbpagech06/fk-rb-pgs-ch06-page66",
      "/rbpagech06/fk-rb-pgs-ch06-page67",
      "/rbpagech06/fk-rb-pgs-ch06-page68",
      "/rbpagech06/fk-rb-pgs-ch06-page69",
      "/rbpagech06/fk-rb-pgs-ch06-page70",
      "/rbpagech06/fk-rb-pgs-ch06-page71",
      "/rbpagech06/fk-rb-pgs-ch06-page72",
      "/rbpagech06/fk-rb-pgs-ch06-page73",
      "/rbpagech06/fk-rb-pgs-ch06-page74",
      "/rbpagech06/fk-rb-pgs-ch06-page75"
    ];
    //var readbookch7_url = [
    //  "/rbpagech07/fk-rb-pgs-ch07-page76",
    //  "/rbpagech07/fk-rb-pgs-ch07-page77",
    //  "/rbpagech07/fk-rb-pgs-ch07-page78",
    //  "/rbpagech07/fk-rb-pgs-ch07-page79",
    //  "/rbpagech07/fk-rb-pgs-ch07-page80",
    //  "/rbpagech07/fk-rb-pgs-ch07-page82",
    //  "/rbpagech07/fk-rb-pgs-ch07-page83"
    //];

    //var readbookch8_url = [
    //  "/rbpagech08/fk-rb-pgs-ch08-page84",
    //  "/rbpagech08/fk-rb-pgs-ch08-page85",
    //  "/rbpagech08/fk-rb-pgs-ch08-page86",
    //  "/rbpagech08/fk-rb-pgs-ch08-page87",
    //  "/rbpagech08/fk-rb-pgs-ch08-page88",
    //  "/rbpagech08/fk-rb-pgs-ch08-page89",
    //  "/rbpagech08/fk-rb-pgs-ch08-page90",
    //  "/rbpagech08/fk-rb-pgs-ch08-page91",
    //  "/rbpagech08/fk-rb-pgs-ch08-page92",
    //  "/rbpagech08/fk-rb-pgs-ch08-page93",
    //  "/rbpagech08/fk-rb-pgs-ch08-page94",
    //  "/rbpagech08/fk-rb-pgs-ch08-page95",
    //  "/rbpagech08/fk-rb-pgs-ch08-page96",
    //  "/rbpagech08/fk-rb-pgs-ch08-page97",
    //  "/rbpagech08/fk-rb-pgs-ch08-page98"
    //];

    //var readbookch9_url = [
    //  "/rbpagech09/fk-rb-pgs-ch09-page100",
    //  "/rbpagech09/fk-rb-pgs-ch09-page101",
    //  "/rbpagech09/fk-rb-pgs-ch09-page102",
    //  "/rbpagech09/fk-rb-pgs-ch09-page103",
    //  "/rbpagech09/fk-rb-pgs-ch09-page104",
    //  "/rbpagech09/fk-rb-pgs-ch09-page105",
    //  "/rbpagech09/fk-rb-pgs-ch09-page106",
    //  "/rbpagech09/fk-rb-pgs-ch09-page107",
    //  "/rbpagech09/fk-rb-pgs-ch09-page108",
    //  "/rbpagech09/fk-rb-pgs-ch09-page109",
    //  "/rbpagech09/fk-rb-pgs-ch09-page110",
    //  "/rbpagech09/fk-rb-pgs-ch09-page111",
    //  "/rbpagech09/fk-rb-pgs-ch09-page112",
    //  "/rbpagech09/fk-rb-pgs-ch09-page113"
    //];

    //var readbookch10_url = [
    //  "/rbpagech10/fk-rb-pgs-ch10-page114",
    //  "/rbpagech10/fk-rb-pgs-ch10-page115",
    //  "/rbpagech10/fk-rb-pgs-ch10-page116",
    //  "/rbpagech10/fk-rb-pgs-ch10-page118",
    //  "/rbpagech10/fk-rb-pgs-ch10-page120",
    //  "/rbpagech10/fk-rb-pgs-ch10-page122",
    //  "/rbpagech10/fk-rb-pgs-ch10-page124",
    //  "/rbpagech10/fk-rb-pgs-ch10-page126",
    //  "/rbpagech10/fk-rb-pgs-ch10-page127",
    //  "/rbpagech10/fk-rb-pgs-ch10-page128",
    //  "/rbpagech10/fk-rb-pgs-ch10-page129"
    //];

    //var readbookch11_url = [
    //  "/rbpagech11/fk-rb-pgs-ch11-page130",
    //  "/rbpagech11/fk-rb-pgs-ch11-page131",
    //  "/rbpagech11/fk-rb-pgs-ch11-page132",
    //  "/rbpagech11/fk-rb-pgs-ch11-page133",
    //  "/rbpagech11/fk-rb-pgs-ch11-page134",
    //  "/rbpagech11/fk-rb-pgs-ch11-page135",
    //  "/rbpagech11/fk-rb-pgs-ch11-page136",
    //  "/rbpagech11/fk-rb-pgs-ch11-page137",
    //  "/rbpagech11/fk-rb-pgs-ch11-page138",
    //  "/rbpagech11/fk-rb-pgs-ch11-page139",
    //  "/rbpagech11/fk-rb-pgs-ch11-page140",
    //  "/rbpagech11/fk-rb-pgs-ch11-page141"
    //];

    //var readbookch12_url = [
    //  "/rbpagech12/fk-rb-pgs-ch12-page142",
    //  "/rbpagech12/fk-rb-pgs-ch12-page143",
    //  "/rbpagech12/fk-rb-pgs-ch12-page144",
    //  "/rbpagech12/fk-rb-pgs-ch12-page146",
    //  "/rbpagech12/fk-rb-pgs-ch12-page147",
    //  "/rbpagech12/fk-rb-pgs-ch12-page148",
    //  "/rbpagech12/fk-rb-pgs-ch12-page150",
    //  "/rbpagech12/fk-rb-pgs-ch12-page152",
    //  "/rbpagech12/fk-rb-pgs-ch12-page154",
    //  "/rbpagech12/fk-rb-pgs-ch12-page156",
    //  "/rbpagech12/fk-rb-pgs-ch12-page157",
    //  "/rbpagech12/fk-rb-pgs-ch12-page158",
    //  "/rbpagech12/fk-rb-pgs-ch12-page159",
    //  "/rbpagech12/fk-rb-pgs-ch12-page160",
    //  "/rbpagech12/fk-rb-pgs-ch12-page161",
    //  "/rbpagech12/fk-rb-pgs-ch12-page162",
    //  "/rbpagech12/fk-rb-pgs-ch12-page163",
    //  "/rbpagech12/fk-rb-pgs-ch12-page164"
    //];


    //var doublepgstext_url = [
    //  "/rbpagech05/fk-rb-pgs-ch05-page54",
    //  "/rbpagech05/fk-rb-pgs-ch05-page56",
    //  "/rbpagech05/fk-rb-pgs-ch05-page58",
    //  "/rbpagech07/fk-rb-pgs-ch07-page80",
    //  "/rbpagech08/fk-rb-pgs-ch08-page98",
    //  "/rbpagech10/fk-rb-pgs-ch10-page116",
    //  "/rbpagech10/fk-rb-pgs-ch10-page118",
    //  "/rbpagech10/fk-rb-pgs-ch10-page120",
    //  "/rbpagech10/fk-rb-pgs-ch10-page122",
    //  "/rbpagech10/fk-rb-pgs-ch10-page124",
    //  "/rbpagech12/fk-rb-pgs-ch12-page144",
    //  "/rbpagech12/fk-rb-pgs-ch12-page148",
    //  "/rbpagech12/fk-rb-pgs-ch12-page150",
    //  "/rbpagech12/fk-rb-pgs-ch12-page152",
    //  "/rbpagech12/fk-rb-pgs-ch12-page154",
    //  "/rbpagech12/fk-rb-pgs-ch12-page156"

    //];


    if (other_url.indexOf(page_active) > -1) {
      $(".rb_ch").hide();
    }
    //if (doublepgstext_url.indexOf(page_active) > -1) {
    //  setTimeout(function () {
    //    $(".t").css("opacity", 1);
    //  }, 800);
    //}
    //else if (doublepgstext_url.indexOf(page_active) > -1) {

    //}

    //if (workbookch1_url.indexOf(page_active) > -1) {
    //  $(".wb_ch_1").show();
    //  $(".rb_ch_1").show();
    //}
    //else if (workbookch2_url.indexOf(page_active) > -1) {
    //  $(".wb_ch_2").show();
    //  $(".rb_ch_2").show();
    //}
    //else if (workbookch3_url.indexOf(page_active) > -1) {
    //  $(".wb_ch_3").show();
    //  $(".rb_ch_3").show();
    //}
    //else if (workbookch4_url.indexOf(page_active) > -1) {
    //  $(".wb_ch_4").show();
    //  $(".rb_ch_4").show();
    //}
    //else if (workbookch5_url.indexOf(page_active) > -1) {
    //  $(".wb_ch_5").show();
    //  $(".rb_ch_5").show();
    //}
    else if (workbookch6_url.indexOf(page_active) > -1) {
      $(".wb_ch_6").show();
      $(".rb_ch_6").show();
    }
    //else if (workbookch7_url.indexOf(page_active) > -1) {
    //  $(".wb_ch_7").show();
    //  $(".rb_ch_7").show();
    //}
    //else if (workbookch8_url.indexOf(page_active) > -1) {
    //  $(".wb_ch_8").show();
    //  $(".rb_ch_8").show();
    //}
    //else if (workbookch9_url.indexOf(page_active) > -1) {
    //  $(".wb_ch_9").show();
    //  $(".rb_ch_9").show();
    //}
    //else if (workbookch10_url.indexOf(page_active) > -1) {
    //  $(".wb_ch_10").show();
    //  $(".rb_ch_10").show();
    //}
    //else if (workbookch11_url.indexOf(page_active) > -1) {
    //  $(".wb_ch_11").show();
    //  $(".rb_ch_11").show();
    //}
    //else if (workbookch12_url.indexOf(page_active) > -1) {
    //  $(".wb_ch_12").show();
    //  $(".rb_ch_12").show();
    //}


    //if (readbookch1_url.indexOf(page_active) > -1) {
    //  $(".rb_ch_1").show();
    //  $(".wb_ch_1").show();

    //}
    //else if (readbookch2_url.indexOf(page_active) > -1) {
    //  $(".rb_ch_2").show();
    //  $(".wb_ch_2").show();
    //}
    //else if (readbookch3_url.indexOf(page_active) > -1) {
    //  $(".rb_ch_3").show();
    //  $(".wb_ch_3").show();
    //}
    //else if (readbookch4_url.indexOf(page_active) > -1) {
    //  $(".rb_ch_4").show();
    //  $(".wb_ch_4").show();
    //}
    //else if (readbookch5_url.indexOf(page_active) > -1) {
    //  $(".rb_ch_5").show();
    //  $(".wb_ch_5").show();
    //}
    else if (readbookch6_url.indexOf(page_active) > -1) {
      $(".rb_ch_6").show();
      $(".wb_ch_6").show();
    }
    //else if (readbookch7_url.indexOf(page_active) > -1) {
    //  $(".rb_ch_7").show();
    //  $(".wb_ch_7").show();
    //}
    //else if (readbookch8_url.indexOf(page_active) > -1) {
    //  $(".rb_ch_8").show();
    //  $(".wb_ch_8").show();

    //}
    //else if (readbookch9_url.indexOf(page_active) > -1) {
    //  $(".rb_ch_9").show();
    //  $(".wb_ch_9").show();

    //}
    //else if (readbookch10_url.indexOf(page_active) > -1) {
    //  $(".rb_ch_10").show();
    //  $(".wb_ch_10").show();
    //}
    //else if (readbookch11_url.indexOf(page_active) > -1) {
    //  $(".rb_ch_11").show();
    //  $(".wb_ch_11").show();
    //}
    //else if (readbookch12_url.indexOf(page_active) > -1) {
    //  $(".rb_ch_12").show();
    //  $(".wb_ch_12").show();
    //}

  }


  updateNetworkStatusUI() {
    if (navigator.onLine) {
      (document.querySelector("body") as any).style = "";
    } else {
      (document.querySelector("body") as any).style = "filter:grayscale(1)";
    }
  }

  async ngAfterViewInit() {

  }

  private loadScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    })
  }
  public ngOnInit() {

    document.addEventListener("touchstart", function () { }, false);
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
    var isEdge = window.navigator.userAgent.indexOf("Edge") > -1;


    if (isIE11 === true || isEdge === true) {


      $('#menu_Tillaren').click(function (e) {

        $(".dropdown-content_Tillaren").show();
      });

      $('.dropdown1_Tillaren').click(function (e) {

        $(".dropdown-content1_Tillaren").show();
      });

      $('.dropdown-content1_Tillaren_close').click(function (e) {

        $(".dropdown-content1_Tillaren").hide();
      });

      $(".foo").click(function () {
        var open_close = $(".dropdown-content_tincan").css("display");
        $(".tincan1").css("display", "none");
        $(".tincan2").css("display", "inline-block");
        $(".dropdown-content_tincan").css("display", "block");
      });


      $('.dropdown1_tincan').click(function (e) {

        $(".dropdown-content1_tincan").show();
      });

      $('.dropdown-content1_tincan_close').click(function (e) {

        $(".dropdown-content1_tincan").hide();
      });
      $('.dropdown2_tincan').click(function (e) {

        $(".dropdown-content2_tincan").show();
      });

      $('.dropdown-content2_tincan_close').click(function (e) {
        $(".dropdown-content2_tincan").hide();
      });

      $('.dropdown3_tincan').click(function (e) {

        $(".dropdown-content3_tincan").show();
      });

      $('.dropdown-content3_tincan_close').click(function (e) {
        $(".dropdown-content3_tincan").hide();
      });

      $('.dropdown4_tincan').click(function (e) {

        $(".dropdown-content4_tincan").show();
      });

    }
    //auto active menu bar
    var current_url = "";
    var old_url = "";
    this.router.events.subscribe((val) => {
      current_url = this.router.url;
      if (current_url != old_url) {
        this.setmenuactive();
        this.setmenulayout();
        old_url = current_url;
      }
    });

  }

  //openalfabetet() {

  //  let dialogRef = this.dialog.open(AlfabetetComponent, {
  //    disableClose: true
  //  });

  //}
  //openKnasigameningar() {

  //  let dialogRef = this.dialog.open(KnasigameningarComponent, {
  //    disableClose: true

  //  });

  //}


  openLyssnaEfterLjudet() {

    let dialogRef = this.dialog.open(LyssnaEfterLjudetComponent, {
      disableClose: true
    });

  }

  //openBladderblocket() {


  //  let dialogRef = this.dialog.open(BladderblocketComponent, {
  //    disableClose: true,
  //    height: "47.3vw"
  //  });

  //}
  //openlyssnapaalfabetetsmall() {

  //  let dialogRef = this.dialog.open(LyssnapaalfabetetsmallComponent, {
  //    disableClose: true
  //  });

  //}
  openlyssnapaalfabetetcaps() {

    let dialogRef = this.dialog.open(LyssnapaalfabetetcapsComponent, {
      disableClose: true
    });

  }

  //openSapbubblor() {

  //  let dialogRef = this.dialog.open(SapbubblorComponent, {
  //    disableClose: true
  //  });

  //}

  //openbokstaverviovat() {

  //  let dialogRef = this.dialog.open(BokstaverviovatComponent, {
  //    disableClose: true
  //  });

  //}

  //openSangAlfabetet() {

  //  let dialogRef = this.dialog.open(SangAlfabetetComponent, {
  //    disableClose: true
  //  });

  //}


  //openSangAlfabetetSjungMed() {

  //  let dialogRef = this.dialog.open(SangAlfabetetSjungMedComponent, {
  //    disableClose: true
  //  });

  //}



  //OpenPdftb0Innehall() {
  //  var strbloburl = this.sessionService.bloburl;
  //  let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.overview.pdf#toolbar=0';
  //  window.open(link, "_blank", "fullscreen=yes");
  //}
  //OpenPdftb0Innehall0() {
  //  var strbloburl = this.sessionService.bloburl;
  //  let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.0.pdf#toolbar=0';
  //  window.open(link, "_blank", "fullscreen=yes");
  //}

  //OpenPdftb0Kapitel1() {
  //  var strbloburl = this.sessionService.bloburl;
  //  let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.1.pdf#toolbar=0';
  //  window.open(link, "_blank", "fullscreen=yes");
  //}

  //OpenPdftb0Kapitel2() {
  //  var strbloburl = this.sessionService.bloburl;
  //  let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.2.pdf#toolbar=0';
  //  window.open(link, "_blank", "fullscreen=yes");
  //}

  //OpenPdftb0Kapitel3() {
  //  var strbloburl = this.sessionService.bloburl;
  //  let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.3.pdf#toolbar=0';
  //  window.open(link, "_blank", "fullscreen=yes");
  //}

  //OpenPdftb0Kapitel4() {
  //  var strbloburl = this.sessionService.bloburl;
  //  let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.4.pdf#toolbar=0';
  //  window.open(link, "_blank", "fullscreen=yes");
  //}

  //OpenPdftb0Kapitel5() {
  //  var strbloburl = this.sessionService.bloburl;
  //  let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.5.pdf#toolbar=0';
  //  window.open(link, "_blank", "fullscreen=yes");
  //}

  OpenPdftb0Kapitel6() {
    var strbloburl = this.sessionService.bloburl;
    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.6.pdf#toolbar=0';
    window.open(link, "_blank", "fullscreen=yes");
  }

//  OpenPdftb0Kapitel7() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.7.pdf#toolbar=0';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb0Kapitel8() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.8.pdf#toolbar=0';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb0Kapitel9() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.9.pdf#toolbar=0';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb0Kapitel10() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.10.pdf#toolbar=0';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb0Kapitel11() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.11.pdf#toolbar=0';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb0Kapitel12() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.12.pdf#toolbar=0';
//    window.open(link, "_blank", "fullscreen=yes");
//  }


//  OpenPdftb1Innehall() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.0.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel1() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.1.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel2() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.2.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel3() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.3.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel4() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.4.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel5() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.5.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel6() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.6.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel7() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.7.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel8() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.8.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel9() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.9.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel10() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.10.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel11() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.11.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  OpenPdftb1Kapitel12() {
//    var strbloburl = this.sessionService.bloburl;
//    let link = strbloburl + '/Lasresan/FK/FK-Tilllararen/Lararhandledning/Pdf/LH.kap.12.pdf#toolbar=1';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//Larare() {
//    let link = '/Lasresan/FK/FK-Tilllararen/l%C3%A4rare/lasresan_FAQ_brev_larare.pdf';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

//  Foraldrar() {
//    let link = '/Lasresan/FK/FK-Tilllararen/vardnadshavare/lasresan_FAQ_brev_vardnadshavare.pdf';
//    window.open(link, "_blank", "fullscreen=yes");
//  }

}
